import gsap from "gsap";

export default function Showcaseblock() {
  Alpine.data("showcaseblock", () => ({
    current: 0,
    total: 0,
    autoplay: true,
    _duration: 10,

    init() {
      this.total = parseInt(this.$el.dataset.total) || 0;
      if (this.total <= 1) return;
      this._play();
    },

    destroy() {
      this._pause();
    },

    _play() {
      const bar = this.$el.querySelector("[data-progress]");
      if (!bar) return;
      gsap.killTweensOf(bar);
      gsap.fromTo(
        bar,
        { scaleX: 0 },
        {
          scaleX: 1,
          duration: this._duration,
          ease: "none",
          transformOrigin: "left center",
          onComplete: () => this.goTo((this.current + 1) % this.total),
        },
      );
    },

    _pause() {
      const bar = this.$el.querySelector("[data-progress]");
      if (bar) gsap.killTweensOf(bar);
    },

    goTo(index) {
      const bottom = this.$refs.bottom;
      gsap.killTweensOf(bottom);

      gsap.to(bottom, {
        opacity: 0,
        y: -20,
        duration: 0.3,
        ease: "power2.in",
        onComplete: () => {
          this.current = index;
          gsap.fromTo(
            bottom,
            { opacity: 0, y: 20 },
            {
              opacity: 1,
              y: 0,
              duration: 0.8,
              ease: "power4.out",
            },
          );
          if (this.autoplay) this._play();
        },
      });
    },

    nav(index) {
      if (index === this.current) return;
      this.autoplay = false;
      this._pause();
      this.goTo(index);
    },
  }));
}
